
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SortingDetailsGrid extends Serenity.EntityGrid<SortingDetailsRow, any> {
        protected getColumnsKey() { return 'Inventory.SortingDetails'; }
        protected getDialogType() { return SortingDetailsDialog; }
        protected getIdProperty() { return SortingDetailsRow.idProperty; }
        protected getInsertPermission() { return SortingDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return SortingDetailsRow.localTextPrefix; }
        protected getService() { return SortingDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}